import { useEffect } from 'react';
import { useBrandConfiguration } from '../../brands/context';
export const useDatadome = () => {
    const { dataDomeConfiguration: { ddJsKey, domain }, } = useBrandConfiguration();
    useEffect(() => {
        window.ddjskey = ddJsKey;
        window.ddoptions = {
            ajaxListenerPath: [`${domain}`],
            sessionByHeader: true,
        };
    }, [ddJsKey, domain]);
};
